import * as React from 'react';
import type { CompanyAutocompleteOption } from '../../../../../../../types/option';
import styled from '@mui/styles/styled';

type Props = CompanyAutocompleteOption & {
    setFocused?: (val: boolean) => void;
};

const AutocompleteCompanyOptionStyled = styled('div')(({ theme: { palette } }: any) => ({
    display: 'flex',
    flexDirection: 'column',
    color: palette.subline,
    '& .name': {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '21px',
    },
    '& .domain': {
        fontSize: '12px',
        lineHeight: '14px',
    },
    '& .industry': {
        color: palette.colors.greyDark,
        fontSize: '12px',
        lineHeight: '14px',
    },
}));

export const AutocompleteCompanyOption = ({ name, website, industry, isValid, setFocused }: Props) => {
    return (
        <AutocompleteCompanyOptionStyled onClick={() => setFocused && setFocused(true)}>
            {!isValid && <div>No match found</div>}
            {isValid && (
                <>
                    <div className="name">{name.charAt(0).toUpperCase() + name.slice(1)}</div>
                    {website && website.length > 0 && <div className="domain">{website}</div>}
                    {industry && industry.length > 0 && <div className="industry">{industry}</div>}
                </>
            )}
        </AutocompleteCompanyOptionStyled>
    );
};
